import {
  P44Theme as Theme,
  makeP44Styles as makeStyles,
} from '../../utils/theme';

import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.grey['100'],
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    width: '100vw',
  },
}));

const Loader = (): React.ReactElement => {
  const classes = useStyles();
  return (
    <div data-testid="loader" className={classes.root}>
      <CircularProgress size={50} />
    </div>
  );
};

export default Loader;
